import { configs } from '../../config';
import { isLocalServer } from '../../Components/Common/checkLocalhost';

/**
 * Get Node Server Base URL based on environment
 */
export const getNodeServerUrl = () => {
  if (isLocalServer()) {
    return 'http://localhost:5000';
  }
  
  const isProd = window.location.hostname === 'mconnectprod.pidilite.in';
  return isProd ? configs?.prod_url : configs?.base_url;
};

/**
 * API Base URLs
 */
export const NODE_SERVER_URL = getNodeServerUrl();
export const SALESFORCE_BASE_URL = configs?.base_url;
export const PCMS_BASE_URL = configs?.pcms_url;

/**
 * API Timeout Configuration
 */
export const API_TIMEOUT = 30000; // 30 seconds

/**
 * API Status Codes
 */
export const API_STATUS_CODES = {
  SUCCESS: 200,
  CREATED: 201,
  NO_CONTENT: 204,
  BAD_REQUEST: 400,
  UNAUTHORIZED: 401,
  FORBIDDEN: 403,
  NOT_FOUND: 404,
  CONFLICT: 409,
  INTERNAL_SERVER_ERROR: 500,
  SERVICE_UNAVAILABLE: 503,
};

/**
 * Retry Configuration for failed requests
 */
export const RETRY_CONFIG = {
  maxRetries: 3,
  retryDelay: 1000, // milliseconds
  retryableStatusCodes: [408, 429, 500, 502, 503, 504],
};

/**
 * Token Configuration
 */
export const TOKEN_CONFIG = {
  tokenLifetime: 30 * 60 * 1000, // 30 minutes in milliseconds
  refreshThreshold: 5 * 60 * 1000, // Refresh 5 minutes before expiry
  maxRefreshRetries: 3,
};

/**
 * Default Headers
 */
export const DEFAULT_HEADERS = {
  'Content-Type': 'application/json',
  Accept: 'application/json',
};

/**
 * Environment Flags
 */
export const IS_DEV = process.env.NODE_ENV === 'development';
export const IS_PROD = process.env.NODE_ENV === 'production';
export const IS_LOCAL = isLocalServer();
